import React from 'react';
import { Link } from 'react-router-dom';
import * as Icons from 'lucide-react';

const sections = [
  {
    title: "Visszatérítések",
    icon: Icons.Wallet,
    description: "Ha rajtunk keresztül jelentkezel be az alábbi cégekhez, akkor a vásárlásod után visszatérítést kapsz. Minden a cégek által biztosított előny, kedvezmény megillet, a visszatérítés ezen felüli."
  },
  {
    title: "Ingyenes előnyök",
    icon: Icons.Gift,
    description: "Igen, ezek ingyenesek, és előnyösek"
  },
  {
    title: "Webshopok",
    icon: Icons.ShoppingBag,
    description: "Ezek az Előny Klubhoz tartozó webshopok, egyedi kínálattal, és természetesen egyedi árakkal."
  },
  {
    title: "Akciók",
    icon: Icons.Tag,
    description: "Partnereink időszakosan biztosított előnyei"
  }
];

export default function Landing() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-indigo-500 to-purple-600">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="text-center mb-16">
          <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold text-white mb-4">
            Előny Klub
          </h1>
          
          <h2 className="text-xl sm:text-2xl md:text-3xl text-white mb-8 tracking-wide">
            <span className="inline-block mx-2">💎</span>
            „Vásárolj, utazz, élj – és közben pénzt kapsz vissza!"
            <span className="inline-block mx-2">💎</span>
          </h2>

          {/* Rólunk szekció */}
          <div className="bg-white bg-opacity-10 backdrop-blur-sm rounded-xl p-8 mb-16">
            <h2 className="text-3xl font-bold text-white mb-6">
              Rólunk
            </h2>
            <div className="text-indigo-100 space-y-4 max-w-4xl mx-auto text-lg leading-relaxed">
              <p>
                Célunk egy olyan közösséget létrehozni, ahol mindenki talál olyan előnyt, 
                ami fontos számára, ami megkönnyíti az életét, céljai elérését. Közösségként 
                sokkal nagyobb előnyöket érhetünk el.
              </p>
              <p>
                Nem akarunk semmire rábeszélni, azt és onnan vehetsz igénybe ahonnan te szeretnéd, 
                ahol megszoktad. Mi egy másik utat mutatunk, ahol plusz előnyhöz jutsz.
              </p>
              <p className="text-2xl font-semibold mt-6">
                A TE KLUBOD, A TE ELŐNYÖD
              </p>
            </div>
          </div>
          
          <p className="text-xl md:text-2xl text-indigo-100 mb-12 max-w-3xl mx-auto leading-relaxed">
            Valódi előnyök, mindenkinek! Egy olyan klub, ahol mindenki talál olyan előnyt, 
            ami megdobogtatja a szívét.
          </p>

          {/* Fő szekciók */}
          <div className="grid md:grid-cols-2 gap-8 mb-16">
            {sections.map((section) => (
              <div key={section.title} className="bg-white bg-opacity-10 backdrop-blur-sm rounded-xl p-8">
                <div className="bg-white rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-6">
                  <section.icon className="h-8 w-8 text-indigo-600" />
                </div>
                <h3 className="text-xl font-semibold text-white mb-4">
                  {section.title}
                </h3>
                <p className="text-indigo-100 mb-2">
                  {section.description}
                </p>
              </div>
            ))}
          </div>

          {/* Passzív jövedelem szekció */}
          <div className="bg-white bg-opacity-10 backdrop-blur-sm rounded-xl p-8 mb-16">
            <h2 className="text-3xl font-bold text-white mb-6">
              Passzív jövedelem
            </h2>
            <div className="text-indigo-100 space-y-4 max-w-3xl mx-auto">
              <p>Mindenki hallott róla, mindenki szeretné, de itt valóban megtalálod.</p>
              <p>
                Munkatársakat keresünk, akik segítenek eljuttatni az Előny Klub előnyeit, 
                filozófiáját, a leendő klub tagoknak. Minden általad hozott klub tag által 
                igénybe vett előny után jutalékot kapsz.
              </p>
              <p>
                A Te szereped addig tart, míg valaki regisztrál a klubba, utána már központi 
                tájékoztatást kap minden klub tag az előnyökről. Tehát ez nem csak nevében 
                passzív jövedelem, itt ez megvalósul.
              </p>
              <p className="text-xl font-semibold">
                Előnyt közvetítesz, és ezzel előnyhöz jutsz. Élvezd az előnyöket, és segíts 
                hozzá másokat is, hogy megismerjék!
              </p>
            </div>
          </div>

          {/* CTA Gombok */}
          <div className="flex justify-center space-x-4">
            <Link
              to="/login"
              className="inline-flex items-center px-8 py-4 bg-white text-lg font-medium rounded-lg text-indigo-600 hover:bg-opacity-90 transition-colors duration-200"
            >
              Csatlakozz most
              <Icons.UserPlus className="ml-2 h-5 w-5" />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
} 